import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/GoogleMapIcon.svg'


const _withScopeId = n => (_pushScopeId("data-v-71fcec6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "google-map" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-1"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("iframe", {
        src: _ctx.googleMapEmbedUrl,
        width: "100%",
        height: "auto",
        frameborder: "0",
        class: "border-0",
        style: _normalizeStyle(_ctx.mapStyle ?? undefined),
        allowfullscreen: ""
      }, null, 12, _hoisted_2)
    ]),
    _createTextVNode(),
    _createElementVNode("button", {
      class: "btn-order mt-2",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickConfirmRoute && _ctx.onClickConfirmRoute(...args)))
    }, [
      _hoisted_3,
      _createTextVNode("\n      Google Mapでルート確認\n    ")
    ])
  ]))
}